<template>

  <div>
      <img src="../assets/my/2026.png" style="height:120px;"/>
      <p style="font-size:large; float:none;">
      				<strong>
      				    Call for Papers
      				</strong>
              <span class="body_text">
                <a :href="`${publicPath}IDASB_2026.pdf`" target="_blank" rel="noopener">
                  flyer in pdf format
                </a>
              </span>
      </p>


      <p>
The IDASB 2026 workshop is the 17th in a series of workshops that aim at providing an international forum to discuss the most recent developments in the field regarding integrated data analysis approaches in systems biology research such as pattern recognition and prediction, modeling and simulation, and data representation and visualisation.
      </p>

      <p>
<!-- &nbsp;The workshop will feature &quot;integrated approach&quot; and &quot;complex biological system&quot; themes. Potential topics include, but are not limited to:
 -->
    &nbsp;This workshop will feature the themes of “integrated approach”,  “modelling and modality,” and  “complex biological system.” The scope of this workshop is to integrate and use genome, transcriptome, single cell omics, epigenome, proteome, metabolome, microbiome, drug, phenotype, and other data to contribute to the understanding of biological system, health and disease. Integration of “omics” data with imaging, functional, structural and lifestyle/environmental data are also welcome. Research areas include, but are not limited to:
      </p>
          <ul class="my-c">
                    <li>	Large-scale or cross-species data integration for the reconstruction of networks and pathways</li>
                    <li>	Genomic data analysis using systems biology approaches </li>
          	<li>	Data science approaches and applications </li>
                    <li>	Large language models and applications in biological and biomedical fields</li>
                    <li>	Analysis, methods and tools for the data from single cells, tissue specificity, and time series.</li>
          	<li>	Dynamics of regulatory, signalling, interaction and metabolic networks through modelling and simulation techniques</li>
          	<li>	Prediction of protein/RNA structure and biological networks interactions</li>
                    <li>	Single cell multi-omics data analysis and visualization </li>
                    <li>	Deep learning of complex biological or biomedical data</li>
                    <li>	Data integration and knowledge driven approach in biomarker identification and drug discovery</li>
          	<li>	Semantic webs and ontology-driven biological data integration methods</li>
          	<li>	Data standardization from multi-domains</li>
          	<li>	Development of integrated systems biology visualisation and analysis tools</li>
          	<li>	Complex network analysis in systems biology</li>
                    <li>Integration of heterogeneous and omics data in medicine</li>
          	<li>	Big data analysis in biological systems</li>
          	<li>	Modality, scalable and interpretable informatics approaches for complex data mining</li>
          	<li>	Multiscale modelling and computing in systems biology and systems medicine</li>

          	<li>	Metagenomics in systems biology</li>
          	<li>	Integrative analysis of omics data with images or phenotypic data.</li>
            <li>	Multi-omics integrated database and web service development in systems biology</li>
            <li>	Integrative analysis of spatial multi-omics data</li>
          </ul>
      <p>
         We invite you to submit papers with unpublished, original research describing recent advances on the areas related to this workshop. All papers will undergo peer review by the conference program committee. All papers accepted will be included in the Workshop Proceedings published by the IEEE Computer Society Press and will be available at the workshops.
      </p>
      <p>
         Authors of selected papers will be invited to extend their papers for submission to a special issue in  <i> International Journal of Computational Biology and Drug Design</i>.
      </p>


<footer-component></footer-component>
  </div>
</template>



<script>
  import FooterComponent from '@/components/Foot/footer.vue'

  export default {
    components: {
      FooterComponent
    },
    data() {
      return {
        publicPath: process.env.BASE_URL
      }
    }
  }
</script>

<style>
  p, li {
    /* 优先用 Times New Roman（常见学术衬线字体），没找到就用系统默认衬线 */
    font-family: "Times New Roman", Times, serif;
    padding: 0px 5px 0px 10px;
    margin: 0px 10px 0px 10px;
    line-height: 2; /* 调整回更接近参考文本的行高 */
    color: black;
    font-weight: normal; /* 参考文本是常规字重，去掉 bold */
    text-align: justify;
    text-justify: inter-ideograph;
    font-size: large;
  }
  .crossed-number {
    position: relative;
  }

  .crossed-number::before {
    content: "";
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    height: 2px;
    background-color: red; /* 划线颜色 */
    transform: translateY(-50%);
    z-index: 1;
  }
</style>
<link rel="stylesheet" href="./my.css">
